import type { ValidationIssueFamily } from './validationIssueFamilies';
import { validationCopy } from '../copy/validationCopy';

export function formatCategory(category: ValidationIssueFamily['category']): string {
  switch (category) {
    case 'mapping':
      return validationCopy.card.category.mapping;
    case 'required-export':
      return validationCopy.card.category.requiredExport;
    case 'connectors':
      return validationCopy.card.category.connectors;
    case 'properties':
      return validationCopy.card.category.properties;
    default:
      return validationCopy.card.category.components;
  }
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}

export function resolveFamilyCountLabel(family: ValidationIssueFamily): string {
  switch (family.countStrategy) {
    case 'fields':
      return validationCopy.card.impact.field(family.affectedCount);
    case 'elements':
      return validationCopy.card.impact.item(family.affectedCount);
    case 'issues':
      return validationCopy.card.impact.issue(family.issueCount);
    default:
      if (family.impactedElementCount > 0) {
        return validationCopy.card.impact.item(family.impactedElementCount);
      }

      return validationCopy.card.impact.affectedItem(family.affectedCount);
  }
}
